export const WS_SERVER_DB_TYPES = {
    // Client -> Server
    DIRECT_CONNECT_REQUEST: 'DATABASE_DIRECT_CONNECT_REQUEST', // Renamed from INITIATE_TEST

    // Server -> Client (via /user/queue/database/status)
    DIRECT_CONNECT_INITIATED: 'DATABASE_DIRECT_CONNECT_INITIATED', // Acknowledgment for direct connect
    // INITIATION_ERROR remains relevant if the initiation itself fails at ServerDbController level

    TYPE_SERVER_LIST: 'DATABASE_SERVER_LIST',
    TYPE_FETCH_ERROR: 'DATABASE_FETCH_ERROR',
    // TYPE_TEST_INITIATED can be removed if DIRECT_CONNECT_INITIATED covers it. Let's keep both for now and match backend if needed.
    TYPE_DIRECT_CONNECT_INITIATED: 'DATABASE_DIRECT_CONNECT_INITIATED'
  };
  
  export const WS_SERVER_DB_TOPICS = {
    // Destination for sending commands from the client to the server
    APP_ENDPOINT: '/database',
    APP_DIRECT_CONNECT: '/direct-connect', // Renamed from INITIATE_TEST
    GET_SERVERS: '/get-servers',
    USER_LIST_DESTINATION: '/list',
    USER_ERROR_DESTINATION: '/error',
    USER_STATUS_DESTINATION: '/status',
  
    // Optional: User-specific queue for acknowledgments/errors related to *starting* the test
    USER_QUEUE_BASE: '/user/queue/database',
    STATUS: '/status',
  };
  
  // Helper to build full app destination path
  export const getDbAppEndpoint = (action) => `${WS_SERVER_DB_TOPICS.APP_ENDPOINT}${action}`;